module.exports = __webpack_public_path__ + "static/technology-4cffe732aa14dac82394baeb8f5da6c3.jpg";